/**
 * @generated SignedSource<<9c641bebeda368ba7c06b8d584884e09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type ServiceEditVariantsSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type ServiceEditVariantsSortMutation$data = {
  readonly updateServiceOptionPositions: boolean;
};
export type ServiceEditVariantsSortMutation = {
  response: ServiceEditVariantsSortMutation$data;
  variables: ServiceEditVariantsSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateServiceOptionPositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServiceEditVariantsSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServiceEditVariantsSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a3b1fc61622fb98a7d9702bc0abc773b",
    "id": null,
    "metadata": {},
    "name": "ServiceEditVariantsSortMutation",
    "operationKind": "mutation",
    "text": "mutation ServiceEditVariantsSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateServiceOptionPositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "8dde55d286c75254f36bcf5ae8e9b1f8";

export default node;
